import { render, staticRenderFns } from "./DetailsContentDefault.vue?vue&type=template&id=c141dd22&scoped=true&"
import script from "./DetailsContentDefault.ts?vue&type=script&lang=ts&"
export * from "./DetailsContentDefault.ts?vue&type=script&lang=ts&"
import style0 from "./DetailsContentDefault.scss?vue&type=style&index=0&id=c141dd22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c141dd22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VRow,VTextarea})
